module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/04-f59a129ad7f649dd5cf14909c9035f26.jpg";